/* ========================================
   LIVE CLOCK - from Lovable Clock component
   Updates every second, matches en-US format
   ======================================== */

(function () {
  'use strict';

  function init() {
    const clocks = document.querySelectorAll('[data-live-clock]');
    if (!clocks.length) return;

    function update() {
      const now = new Date();

      const dateStr = now.toLocaleDateString('en-US', {
        weekday: 'short',
        day: '2-digit',
        month: 'short',
        year: 'numeric'
      });

      clocks.forEach(function (clock) {
        const use24h = clock.getAttribute('data-time-format') !== 'false';

        const timeStr = now.toLocaleTimeString('en-US', {
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
          hour12: !use24h
        });

        let tz = '';
        try {
          const resolved = Intl.DateTimeFormat().resolvedOptions().timeZone;
          if (resolved) {
            tz = resolved.split('/').pop().replace(/_/g, ' ');
          }
        } catch (e) {
          tz = '';
        }

        const dateEl = clock.querySelector('[data-clock-date]');
        const timeEl = clock.querySelector('[data-clock-time]');
        const tzEl = clock.querySelector('[data-clock-tz]');

        if (dateEl) dateEl.textContent = dateStr;
        if (timeEl) timeEl.textContent = timeStr;
        if (tzEl) tzEl.textContent = tz;
      });
    }

    update();
    setInterval(update, 1000);
  }

  if (document.readyState !== 'loading') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }
})();
